

























































import { Component, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetListByCode } from "@/api/configureDictionary";
import {
  GetPatientEducationPlanList,
  PatientEducationPlanDelete,
  SavePatientEducationPlan
} from "@/api/pdEducationPlan/pdPatientEducationPlan";
import PdPatientEducationPlanAdd from "./pdPatientEducationPlanAdd.vue";
import PdPatientEducationPlanStep from "./pdPatientEducationPlanStep.vue";
@Component({
  components: {
    PdPatientEducationPlanAdd,
    PdPatientEducationPlanStep
  }
})
export default class PdPatientEducationPlan extends AbpBase {
  @Prop() patient: any;
  showAddPatientEducationPlan: boolean = false;
  showAddPatientEducationPlanStep: boolean = false;
  loading: boolean = false;
  pdPatientEducationPlan: any = {};
  PatientEducationPlanRequest: any = {
    PlanName: "",
    SkipCount: 1,
    MaxResultCount: 10,
    SortKey: "id",
    SortOrder: "asc"
  };
  /**
   * 表格数据
   */
  tableData: any[] = [];
  tableTotalSize: number = 0;
  PatientEducationPlanDetailed = [
    {
      title: "患者姓名",
      key: "pname",
      minWidth: 80
    },
    {
      title: "计划名称",
      key: "planName",
      minWidth: 180
    },
    {
      title: "计划说明",
      key: "planDescription",
      minWidth: 250
    },
    {
      title: "开始时间",
      key: "startTime",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDateTime(p.row.startTime));
      }
    },
    {
      title: "结束时间",
      key: "endTime",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDateTime(p.row.endTime));
      }
    },
    {
      title: "创建时间",
      key: "creationTime",
      minWidth: 140,
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDateTime(p.row.creationTime));
      }
    },
    {
      title: "创建人",
      key: "creationUser",
      minWidth: 80
    },
    {
      title: "操作",
      key: "",
      minWidth: 120,
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "info", icon: "ios-play", size: "small" },
            style: { marginRight: "5px" },
            domProps: {
              title: "执行宣教"
            },
            on: {
              click: () => {
                this.onPatientEducationPlanStep(p.row);
              }
            }
          }),
          h("Button", {
            props: { type: "error", icon: "md-close-circle", size: "small" },
            style: { marginRight: "5px" },
            domProps: {
              title: "删除"
            },
            on: {
              click: () => {
                this.onPatientEducationPlanDelete(p.row.id);
              }
            }
          })
        ]);
      }
    }
  ];
  @Watch("patient", { immediate: false, deep: true })
  async getData() {
    this.loading = true;
    this.PatientEducationPlanRequest.pD_Patient_ID = this.patient.id;
    let res = await GetPatientEducationPlanList(
      this.PatientEducationPlanRequest
    );
    this.tableData = res.items;
    this.tableTotalSize = res.totalCount;
    this.loading = false;
  }

  onPatientEducationPlanDelete(id: number) {
    this.$confirm("确定要删除吗？", "提示").then(async () => {
      await PatientEducationPlanDelete(id);
      this.getData();
    });
  }

  async ColseDiag() {
    this.showAddPatientEducationPlan = false;
    await this.getData();
  }
  async onAddPatientEducationPlanClose() {
    this.showAddPatientEducationPlanStep = false;
    this.getData();
  }
  initDic() {}
  constructor() {
    super();
    this.initDic();
  }
  pageChange(val: any) {
    this.PatientEducationPlanRequest.SkipCount = val;
    this.getData();
  }

  onSortChange(res: any) {
    this.PatientEducationPlanRequest.SortKey = res.key;
    this.PatientEducationPlanRequest.SortOrder = res.order;
    this.getData();
  }

  onPatientEducationPlanStep(data: any) {
    this.pdPatientEducationPlan = data;
    this.showAddPatientEducationPlanStep = true;
  }

  onAddPatientEducationPlan() {
    this.showAddPatientEducationPlan = true;
  }

  created(){
    this.getData() 
  }
  
  async onAddPatientEducationPlanOk() {
    this.showAddPatientEducationPlan = false;
    let res = this.$refs.PdPatientEducationPlanAdd.onSubmit();
    //提交数据
    let requestData = {
      PD_Patient_ID: this.patient.id,
      PDEducationPlanList: res
    };
    this.loading = true;
    await SavePatientEducationPlan(requestData);
    this.loading = false;
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdPatientEducationPlan/index.vue